import { Actor } from "../actors/Actor";

export type AITraits = (
  actor: Actor
) => [number, Action<any>] | undefined | null;

export type ActionResult = {
  valid: boolean;
};

export type Performer<T> = (
  actor: Actor,
  options: T
) => ActionResult | Promise<ActionResult>;

export type Action<T> = {
  actor: Actor;
  options: T;
  perform: Performer<T>;
};

export function createAction<T>(
  performer: Performer<T>,
  actor: Actor,
  options: T
): Action<T> {
  return {
    perform: performer,
    options,
    actor,
  };
}

export function runAction<T>(action: Action<T>) {
  return action.perform(action.actor, action.options);
}
